import { useNavigate } from "react-router-dom";
import Button from "shared/components/Button";
import { ArrowCircleLeftIcon } from "@phosphor-icons/react";

const BackLink = ({ label = "Back", to = -1, className = "" }) => {
  const navigate = useNavigate();

  return (
    <div className={`back__link ${className}`}>
      <Button
        mode="gray"
        size="small"
        icon={<ArrowCircleLeftIcon height={16} width={16} />}
        iconPosition="left"
        onClick={() => navigate(to)}
      >
        {label}
      </Button>
    </div>
  );
};

export default BackLink;
